const _http = "http:";
const _https = "https:";
const _mailto = "mailto:";
const _tel = "tel:";
const _sms = "sms:";
const ALLOWED_PROTOCOLS = new Set([_http, _https, _mailto, _tel, _sms]);

const REGEX = {
  ip: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}$/,
  email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  phone: /^[\d\s+\-()]+$/,
  dangerous: /javascript:|data:|vbscript:|file:/i,
};

const isValidURL = (_href) => {
  if (!_href || typeof _href !== "string") {
    return false;
  }

  const href = normalizeUrl(_href.trim());
  try {
    const url = new URL(href);
    const protocol = url.protocol.toLowerCase();
    if (!ALLOWED_PROTOCOLS.has(protocol)) {
      return false;
    }
    if (REGEX.dangerous.test(href)) {
      return false;
    }
    if (protocol === "http:" || protocol === "https:") {
      if (REGEX.ip.test(url.hostname)) {
        return false;
      }
      if (!url.hostname.includes(".")) {
        return false;
      }
      return true;
    }
    if (protocol === "mailto:") {
      return REGEX.email.test(url.pathname);
    }
    if (protocol === "tel:" || protocol === "sms:") {
      return REGEX.phone.test(url.pathname);
    }

    return false;
  } catch (e) {
    const protocol = href.split(":")[0] + ":"
    return ALLOWED_PROTOCOLS.has(protocol)
  }
};

const urlOptions = {
  invalid: 'invalid',
  web: 'web',
  email: 'email',
  phone: 'phone',
  text: 'text',
}

const getUrlType = (href) => {
  if (!isValidURL(href)) {
    return urlOptions.invalid;
  }

  if (href.startsWith(_mailto)) return urlOptions.email;
  if (href.startsWith(_tel)) return urlOptions.phone;
  if (href.startsWith(_sms)) return urlOptions.text;
  return urlOptions.web;
};

const normalizeUrl = (href) => {
  if (!href) return href;
  return href.startsWith("www.") ? `https://${href}` : href;
};

const ValidatedURL = {
  options: urlOptions,
  getType: getUrlType
}

export default ValidatedURL